import { createRouter, createWebHistory } from 'vue-router'
import Index from '../views/pc/index.vue'
import Product from '../views/pc/product.vue'
// import Index from '../views/pc/index.vue'
// import Index from '../views/pc/index.vue'
// import Index from '../views/pc/index.vue'


const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
  },
  {
    path:'/product/:id',
    name:'product',
    component:Product,
  },
  {
    path:'/customMade/:id',
    name:'customMade',
    component:() => import('../views/pc/customMade.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/pc/about.vue')
  },
  {
    path: '/release',
    name: 'release',
    component: () => import(/* webpackChunkName: "about" */ '../views/pc/release.vue')
  },
  {
    path:'/experience',
    name:'experience',
    component:() => import('../views/pc/experience.vue')
  },
  {
    path:'/regulation',
    name:'regulation',
    component:() => import('../views/pc/regulation.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
